module.exports = __webpack_public_path__ + "img/icon56.049ec3dd.png";